import { render } from "./productModelSelection.vue?vue&type=template&id=971ce09a&scoped=true"
import script from "./productModelSelection.vue?vue&type=script&lang=js"
export * from "./productModelSelection.vue?vue&type=script&lang=js"

import "./productModelSelection.vue?vue&type=style&index=0&id=971ce09a&lang=less&scoped=true"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971ce09a"]])

export default __exports__